import { render, staticRenderFns } from "./ImageAsDataUrlRenderer.vue?vue&type=template&id=164c5684&"
import script from "./ImageAsDataUrlRenderer.vue?vue&type=script&lang=ts&"
export * from "./ImageAsDataUrlRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports